import * as _ from 'lodash';
import { convertMinutesToHHMM, convertHHMMToMinutes } from '../../../HelperMethods/DateUtils';
import * as DateUtils from '../../../HelperMethods/DateUtils';
import { ASSET_TYPES } from '../../../HelperMethods/enums';
import { parseJSONStringToObject } from '../../../HelperMethods/UtilityFunctions';

function convertApproverDataToApproverFormData(approver, obj = { enabled: false, rows: [] }) {
  const approverObj = approver;
  if (_.isString(approver)) {
    convertApproverDataToApproverFormData(JSON.parse(approver), obj);
  } else if (approverObj?.data) {
    for (const [globalAttribute, limit] of Object.entries(approverObj.data)) {
      obj.rows.push({ globalAttribute, limit: `${limit}` });
    }
    obj.enabled = approverObj.enabled;
  }
  return null;
}

function convertApproverFormDataToApproverData(approver) {
  const data = {};
  for (const { globalAttribute, limit } of approver.rows) {
    data[globalAttribute] = parseInt(limit, 10);
  }

  return JSON.stringify({ enabled: approver.enabled, data });
}

function SearchFieldNamefromfieldid(fieldId, fieldDict) {
  return fieldDict.find((value) => {
    return value.id === fieldId;
  });
}

function addStopintoMobileSettings(assetTypesToDownload) {
  const tempassetTypesToDownload = _.cloneDeep(assetTypesToDownload);

  return ['stop', ...tempassetTypesToDownload];
}

function setmobileSettingsFunc(obj, user) {
  // if types exist then add the type with stop
  // if type dosent exist then add all the type by default
  const tempObj = _.clone(obj);
  const assetOptions = _.keyBy(ASSET_TYPES, 'value');

  tempObj.mobileSettings = {
    assetTypesToDownload: [...Object.keys(assetOptions)],
  };

  let mobileSettings = user.mobileSettings || tempObj.mobileSettings;
  if (typeof mobileSettings === 'string') {
    mobileSettings = JSON.parse(mobileSettings);
  }
  const { assetTypesToDownload } = mobileSettings;
  if (!_.isEmpty(assetTypesToDownload) && !assetTypesToDownload.includes('stop')) {
    mobileSettings = {
      assetTypesToDownload: addStopintoMobileSettings(assetTypesToDownload),
    };
  }

  tempObj.mobileSettings.assetTypesToDownload = _.get(mobileSettings, 'assetTypesToDownload') || [];
  return tempObj;
}

export function userToUserManagementObj({ user, teams, rawAreas, fieldsDict, vendorsDict = {}, rolesDict = {} }) {
  const objArray = [];
  if (fieldsDict) {
    Object.values(fieldsDict).forEach((items) => {
      objArray.push(items);
    });
  }

  const obj = {};
  // obj.xid = user.xid || null;
  obj.id = user.id;
  obj.email = user.email;
  obj.timeZone = user.timeZone;
  obj.name = `${user.firstName || ''} ${user.lastName || ''}`;
  obj.isEquipmentResource = user.isEquipmentResource || false;
  obj.equipmentResource = user.isEquipmentResource ? 'Yes' : 'No';
  obj.firstName = user.firstName;
  obj.lastName = user.lastName;
  obj.joyn2Roles = user.joyn2Roles || [];
  obj.joynFSMRoleNames = obj.joyn2Roles
    .map((id) => rolesDict?.[id]?.name)
    .filter((name) => name)
    .join(', ');
  obj.startStopId = user.startStopId;
  obj.endStopId = user.endStopId;
  obj.offDays = user.offDays || [];
  obj.onDays = user.onDays || [];
  obj.userName = user.userName;
  obj.certificates = user.certificates || [];
  obj.contacts = user.contacts || [];
  obj.defaultContact = user.defaultContact || null;
  obj.skillLevel = user.skillLevel || null;
  obj.contractHourlyRate = user.contractHourlyRate || 0;
  obj.startTime = user.shiftStartTime ? convertMinutesToHHMM(user.shiftStartTime) : '';
  obj.endTime = user.shiftEndTime ? convertMinutesToHHMM(user.shiftEndTime) : '';
  obj.hitchStartDate = _.get(user, 'hitch.hitchStartDate', null);
  obj.hitchPattern =
    user.hitch && user.hitch.hitchPattern && Array.isArray(user.hitch.hitchPattern) ? user.hitch.hitchPattern : [];
  obj.startStopId = user.startStopId || '';
  obj.endStopId = user.endStopId || '';
  const userTeamIds =
    Array.isArray(user.teams) && user.teams.length
      ? user.teams.filter((team) => !team.isDeleted).map((team) => team.teamId)
      : [];
  obj.teamIds = teams.filter((team) => !team.isDeleted && userTeamIds.includes(team.id)).map((team) => team.id);
  obj.teamNames = teams
    .filter((team) => !team.isDeleted && userTeamIds.includes(team.id))
    .map((team) => team.name)
    .join(', ');
  obj.userTeamMapping = _.keyBy(
    user?.teams?.filter((val) => !val.isDeleted),
    'teamId'
  );
  obj.areaTeamMapping = {};
  rawAreas
    .filter((area) => area.fieldId === user.fieldId)
    .forEach((area) => {
      obj.areaTeamMapping[area.id] = {};
      for (const team of area?.teams || []) {
        if (team.isDeleted) {
          continue;
        }
        const resources = team?.resources?.filter((val) => !val.isDeleted);
        for (const { userId, resourceLevel, isDeleted } of resources) {
          if (!isDeleted && userId === user.id && resourceLevel === 'primary') {
            if (!obj.areaTeamMapping[area.id].primary) {
              obj.areaTeamMapping[area.id].primary = [];
            }
            obj.areaTeamMapping[area.id].primary.push(team.teamId);
          } else if (!isDeleted && userId === user.id && resourceLevel === 'secondary') {
            if (!obj.areaTeamMapping[area.id].secondary) {
              obj.areaTeamMapping[area.id].secondary = [];
            }
            obj.areaTeamMapping[area.id].secondary.push(team.teamId);
          }
        }
      }
      if (!obj.areaTeamMapping[area.id]?.secondary?.length && !obj.areaTeamMapping[area.id]?.primary?.length) {
        delete obj.areaTeamMapping[area.id];
      }
    });
  obj.areaNames = userTeamIds.length
    ? rawAreas
        .filter((area) => {
          if (!Array.isArray(area.teams)) {
            return false;
          }
          if (area.fieldId !== user.fieldId) {
            return false;
          }
          for (const team of area.teams) {
            const resourceIds = team?.resources?.filter((val) => !val.isDeleted)?.flatMap((val) => val.userId) || [];
            if (!team.isDeleted && userTeamIds?.includes(team.teamId) && resourceIds?.includes(user.id)) {
              return true;
            }
          }
          return false;
        })
        .map((area) => area.name)
        .join(', ')
    : [];
  obj.vendorId = user.vendorId || null;
  obj.aclQualifiedId = user.aclQualifiedId || null;
  obj.businessTitle = user.businessTitle || null;
  obj.allowReassignmentOnMobile = user.allowReassignmentOnMobile || false;
  const deviceMetadata = parseJSONStringToObject(_.get(user, 'deviceMetadata')) || {};
  obj.deviceMetadata = deviceMetadata;
  obj.appVersion = '-';
  obj.locationPermission = '-';
  obj.vendorName = user.vendorId ? vendorsDict?.[user.vendorId]?.name : '';

  if (deviceMetadata) {
    const deviceVersion = _.get(deviceMetadata, 'appVersion', '-');
    const locationPermission = _.get(deviceMetadata, 'LocationPermission', '-');
    obj.appVersion = deviceVersion;
    obj.locationPermission = locationPermission;
  }

  // eslint-disable-next-line no-nested-ternary
  const approverObj = { enabled: false, rows: [] };
  convertApproverDataToApproverFormData(user.approver, approverObj);
  obj.approver = approverObj;

  obj.fieldId = user.fieldId || '';
  obj.fieldName = SearchFieldNamefromfieldid(user.fieldId, objArray)?.name || 'unassigned';

  obj.createdBy = user.createdBy || '';
  obj.createdOn = user.createdOn ? DateUtils.convertUTCDateStringToYYYYMMDDHHMMSSFormat(user.createdOn) : '';
  obj.modifiedBy = user.modifiedBy || '';
  obj.modifiedOn = user.modifiedOn ? DateUtils.convertUTCDateStringToYYYYMMDDHHMMSSFormat(user.modifiedOn) : '';
  obj.cognitoUserName = user.cognitoUserName || '';

  return setmobileSettingsFunc(obj, user);
}

function hitchpatternMapper(hitchList) {
  const returnList = [];

  if (_.isArray(hitchList)) {
    // eslint-disable-next-line guard-for-in
    for (const hitch of hitchList) {
      const returnObj = {};

      Object.keys(hitch).forEach((k) => {
        if (_.isNull(hitch[k])) {
          returnObj[k] = null;
        } else if (_.isString(hitch[k])) {
          let tempValue = null;
          try {
            tempValue = JSON.parse(hitch[k]);
            returnObj[k] = tempValue;
          } catch (e) {
            console.error(e);
            returnObj[k] = null;
          }
        } else {
          returnObj[k] = hitch[k];
        }
      });
      returnList.push(returnObj);
    }
    return returnList;
  }
  return [{ hitchOffDays: null, hitchWorkDays: null, sortOrder: null }];
  // check for string
  // empty values hsould be null
  // string should be converted to int
}

export function userMangementObjToUser(userManagementObj, userCreateFlag) {
  const user = {};

  user.id = userManagementObj.id;
  if (!userManagementObj.id) {
    user.iscreatedFromFSM = true;
  }

  user.isEquipmentResource = userManagementObj.isEquipmentResource || false;
  user.email = userManagementObj.email || '';
  user.joyn2Roles = userManagementObj.joyn2Roles;
  user.contacts = userManagementObj.contacts;
  user.defaultContact = userManagementObj.defaultContact || null;
  user.timeZone = userManagementObj.timeZone;
  user.startStopId = userManagementObj.startStopId;
  user.endStopId = userManagementObj.endStopId;
  user.shiftStartTime = userManagementObj.startTime ? convertHHMMToMinutes(userManagementObj.startTime) : null;
  user.shiftEndTime = userManagementObj.endTime ? convertHHMMToMinutes(userManagementObj.endTime) : null;
  user.offDays = userManagementObj.offDays;
  user.onDays = userManagementObj.onDays || [];
  if (userManagementObj.email) {
    user.email = (userManagementObj.email || '').toLowerCase();
  }
  if (_.isEmpty(userManagementObj.email)) {
    user.email = null;
  }
  user.firstName = userManagementObj.firstName;
  user.lastName = userManagementObj.lastName;
  user.userName = (userManagementObj.userName || '').toLowerCase();
  user.isDeleted = false;
  user.fieldId = userManagementObj.fieldId;
  if (userCreateFlag) {
    user.password = userManagementObj.password;
  }

  user.certificates = userManagementObj.certificates
    .filter((cert) => cert.id)
    .map((cert) => {
      if (!cert.isExpirable || !cert.expiryDate) {
        return { id: cert.id, name: cert.name, isExpirable: false };
      }
      return cert;
    });
  user.contractHourlyRate = userManagementObj.contractHourlyRate || 0;
  user.hitch = {};

  if (userManagementObj.hitchPattern) {
    user.hitch.hitchPattern = hitchpatternMapper(userManagementObj.hitchPattern);
  }
  user.hitch.hitchStartDate = userManagementObj.hitchStartDate || null;

  // user.hitch.hitchPattern = userManagementObj.hitchPattern;
  user.vendorId = userManagementObj.vendorId || null;
  user.skillLevel = userManagementObj.skillLevel || null;
  user.aclQualifiedId = userManagementObj.aclQualifiedId || null;
  user.businessTitle = userManagementObj.businessTitle || null;
  user.allowReassignmentOnMobile = userManagementObj.allowReassignmentOnMobile || false;
  user.vendorId = userManagementObj.vendorId || null;
  user.approver = userManagementObj.approver ? convertApproverFormDataToApproverData(userManagementObj.approver) : null;
  user.mobileSettings = {
    assetTypesToDownload: [],
  };
  user.mobileSettings.assetTypesToDownload = _.get(userManagementObj, 'mobileSettings.assetTypesToDownload') || [];
  user.deviceMetadata = userManagementObj.deviceMetadata;
  user.teams = Object.values(userManagementObj.userTeamMapping || {});
  return { usersData: [user], isCreate: userCreateFlag };
}

export function mergeCertificates(formCertificates, originalCertificates) {
  const originalCertificatesDict = _.keyBy(originalCertificates, 'id');
  formCertificates.forEach((cert) => {
    let updatedCertObj = {};
    if (!cert.isExpirable || !cert.expiryDate) {
      updatedCertObj = { id: cert.id, name: cert.name, isExpirable: false };
    } else updatedCertObj = cert;
    originalCertificatesDict[cert.id] = updatedCertObj;
  });
  return Object.values(originalCertificatesDict);
}

function checkForOnOffDaysBulkUser(onDay, offDay, user) {
  const { offDays, onDays } = user;
  const offDayTobeReturned = _.uniq([...offDays, ...offDay]);
  const onDayTobereturned = _.uniq([...onDays, ...onDay]);
  // check for onday in offDayTobeReturned
  onDay.forEach((onDayPresent) => {
    const index = offDayTobeReturned.indexOf(onDayPresent);
    if (index !== -1) {
      offDayTobeReturned.splice(index, 1);
    }
  });

  // check for offday in onDayTobeReturned
  offDay.forEach((onDayPresent) => {
    const index = onDayTobereturned.indexOf(onDayPresent);
    if (index !== -1) {
      onDayTobereturned.splice(index, 1);
    }
  });
  return { onDays: onDayTobereturned, offDays: offDayTobeReturned };
}

// function onDaysandOffDaysforBulkUser(days, userDays = []) {
//   return _.uniq([...days, ...userDays]);
// }

export function bulkUserMangementObjToUser(obj, originalUserManagementObj) {
  const user = {};
  user.id = originalUserManagementObj.id;
  user.isDeleted = false;
  user.userName = (originalUserManagementObj.userName || '').toLowerCase();
  user.email = (originalUserManagementObj.email || '').toLowerCase();
  user.firstName = originalUserManagementObj.firstName;
  user.lastName = originalUserManagementObj.lastName;
  if ((_.isArray(obj.onDays) || _.isArray(obj.offDays)) && (!_.isEmpty(obj.onDays) || !_.isEmpty(obj.offDays))) {
    const { onDays, offDays } = checkForOnOffDaysBulkUser(obj.onDays, obj.offDays, originalUserManagementObj);
    user.onDays = onDays;
    user.offDays = offDays;
  }
  // if (_.isArray(obj.onDays) && !_.isEmpty(obj.onDays)) {
  //   user.onDays = onDaysandOffDaysforBulkUser(obj.onDays, originalUserManagementObj.onDays);
  // }
  // if (_.isArray(obj.offDays) && !_.isEmpty(obj.offDays)) {
  //   user.offDays = onDaysandOffDaysforBulkUser(obj.offDays, originalUserManagementObj.offDays);

  //   // user.offDays = obj.offDays;
  // }
  if (obj.fieldId) {
    user.fieldId = obj.fieldId;
  }
  if (obj.joyn2Roles) {
    user.joyn2Roles = obj.joyn2Roles;
  }
  if (obj.mobileSettings && !_.isEmpty(_.get(obj, 'mobileSettings.assetTypesToDownload'), [])) {
    const value = _.get(obj, 'mobileSettings.assetTypesToDownload', []);
    _.set(user, 'mobileSettings.assetTypesToDownload', value);
  }
  if (obj.contacts) {
    user.contacts = obj.contacts;
  }
  if (obj.defaultContact) {
    user.defaultContact = obj.defaultContact;
  }
  if (obj.timeZone) {
    user.timeZone = obj.timeZone;
  }
  if (obj.startStopId) {
    user.startStopId = obj.startStopId;
  }
  if (obj.endStopId) {
    user.endStopId = obj.endStopId;
  }
  if (obj.startTime) {
    user.shiftStartTime = convertHHMMToMinutes(obj.startTime);
  }
  if (obj.endTime) {
    user.shiftEndTime = convertHHMMToMinutes(obj.endTime);
  }
  if (obj.vendorId) {
    user.vendorId = obj.vendorId;
  }
  if (obj.contractHourlyRate) {
    user.contractHourlyRate = obj.contractHourlyRate;
  }
  if (obj.hitchStartDate || obj.hitchPattern.length > 0) {
    user.hitch = {};

    // if (userManagementObj.hitchPattern) {
    //   user.hitch.hitchPattern = hitchpatternMapper(userManagementObj.hitchPattern);
    // }
    // user.hitch.hitchStartDate = userManagementObj.hitchStartDate || null;
    user.hitch = {
      hitchStartDate: obj.hitchStartDate,
      hitchPattern: hitchpatternMapper(obj.hitchPattern),
      // originalUserManagementObj.hitchPattern,
    };
  }
  if (obj.hitchStartDate) {
    user.hitch.hitchStartDate = obj.hitchStartDate;
  }
  if (obj.hitchPattern.length > 0) {
    user.hitch.hitchPattern = obj.hitchPattern;
  }
  if (obj.skillLevel) {
    user.skillLevel = obj.skillLevel;
  }
  if (obj.certificates && obj.certificates.length) {
    const updatedCertificates = mergeCertificates(obj.certificates, originalUserManagementObj.certificates);
    user.certificates = updatedCertificates;
  }
  if (obj.allowReassignmentOnMobile) {
    user.allowReassignmentOnMobile = obj.allowReassignmentOnMobile;
  }

  return user;
}
